import { Outlet, useNavigate } from 'react-router-dom';
import { getEnvOrThrow, MonkProvider } from '@monkvision/common';
import { useTranslation } from 'react-i18next';
import { LiveConfig } from '@monkvision/types';
import { LiveConfigAppProvider } from '@monkvision/common-ui-web';
import { Page } from '../pages';
import * as localConfigUs from '../local-config-us.json';
import { AppContainer } from './AppContainer';

const LIVE_CONFIG_ID = getEnvOrThrow('REACT_APP_LIVE_CONFIG_ID');

function getLocalConfigProp(): LiveConfig | undefined {
  if (process.env['REACT_APP_USE_LOCAL_CONFIG'] !== 'true') {
    return undefined;
  }
  return localConfigUs as unknown as LiveConfig;
}

export function App() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  return (
    <LiveConfigAppProvider
      id={LIVE_CONFIG_ID}
      localConfig={getLocalConfigProp()}
      onFetchAuthToken={() => navigate(Page.DASHBOARD)}
      onFetchLanguage={(lang) => i18n.changeLanguage(lang)}
      lang={i18n.language}
    >
      <MonkProvider>
        <AppContainer>
          <Outlet />
        </AppContainer>
      </MonkProvider>
    </LiveConfigAppProvider>
  );
}
